export const MASK_PLACEHOLDER_IMG_W = 1344
export const MASK_PLACEHOLDER_IMG_H = 896
export const MASK_PLACEHOLDER_IMG_SRC =
  'https://res.cloudinary.com/almanac/image/upload/v1715936829/blaze_assets/designer/mask-placeholder_ixguel.png'
export const MASK_PLACEHOLDER_PREVIEW_IMG_SRC =
  'https://res.cloudinary.com/almanac/image/upload/v1715936810/blaze_assets/designer/mask-preview-placeholder_ldwwup.png'
